import { useEffect } from 'react'
import { useLocation } from '@reach/router'
import Cookies from 'js-cookie'
import { OverlayConstants } from '../components/OverlayContext'

function isRelevantPath(pathname: string) {
  const relevantPaths = new RegExp('^(/|/search/?|/ja/?|/zh-cn/?)$')
  return relevantPaths.test(pathname)
}

function isAustralianUser() {
  return (
    Cookies.get('USER-COUNTRY') === 'AU' ||
    !!localStorage.getItem('show-australia-overlay')
  )
}

export default function useAustralianOverlay(
  toggleOverlay: (overlay: OverlayConstants) => void
) {
  const location = useLocation()

  const handleAustralianUser = () => {
    const australiaUserType = Cookies.get('AUS_USERTYPE')
    if (!australiaUserType) {
      toggleOverlay(OverlayConstants.AUSTRALIA_OVERLAY)
    } else if (australiaUserType === 'retail') {
      window.location.assign('https://asic.gov.au/')
    }
  }

  useEffect(() => {
    if (isRelevantPath(location.pathname) && isAustralianUser()) {
      handleAustralianUser()
    }
  }, [location.pathname])

  return null
}

export const testables = {
  isRelevantPath,
  isAustralianUser
}
